import React from 'react';
import { CreditCard, Calendar, Percent } from 'lucide-react';

/**
 * Компонент для ввода базовых параметров кредита
 */
const LoanParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Сумма кредита */}
      <div>
        <label htmlFor="loanAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CreditCard className="w-4 h-4 mr-2 text-green-500" />
          Сумма кредита
        </label>
        <input
          type="text"
          id="loanAmount"
          name="loanAmount"
          value={formData.loanAmount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.loanAmount ? 'input-error' : ''}`}
          placeholder="Введите сумму кредита"
        />
        {errors.loanAmount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.loanAmount}
          </p>
        )}
      </div>

      {/* Срок кредита */}
      <div>
        <label htmlFor="loanTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-green-500" />
          Срок кредита (лет)
        </label>
        <input
          type="text"
          id="loanTerm"
          name="loanTerm"
          value={formData.loanTerm}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.loanTerm ? 'input-error' : ''}`}
          placeholder="Введите срок в годах"
        />
        {errors.loanTerm && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.loanTerm}
          </p>
        )}
      </div>

      {/* Процентная ставка */}
      <div>
        <label htmlFor="interestRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Percent className="w-4 h-4 mr-2 text-green-500" />
          Процентная ставка (%)
        </label>
        <input
          type="text"
          id="interestRate"
          name="interestRate"
          value={formData.interestRate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.interestRate ? 'input-error' : ''}`}
          placeholder="Введите годовую процентную ставку"
        />
        {errors.interestRate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.interestRate}
          </p>
        )}
      </div>

      {/* Дата начала кредита */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-green-500" />
          Дата начала кредита
        </label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          value={formData.startDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
        />
        {errors.startDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.startDate}
          </p>
        )}
      </div>

      {/* Тип платежа */}
      <div className="col-span-full">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Тип платежа
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="paymentType"
              value="annuity"
              checked={formData.paymentType === 'annuity'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Аннуитетный (равные платежи)
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="paymentType"
              value="differentiated"
              checked={formData.paymentType === 'differentiated'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Дифференцированный (уменьшающийся)
            </span>
          </label>
        </div>
        {errors.paymentType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.paymentType}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoanParametersSection;